
import { motion } from 'framer-motion';
import { FileText, FileImage, File, Download, FileBadge, FileCode } from 'lucide-react';

const Downloads = () => {
  const downloads = [{
    id: 1,
    title: 'Technická dokumentace',
    description: 'Kompletní dokumentace svěráku včetně rozměrů, materiálů a montážního postupu.',
    icon: FileText,
    fileSize: '2.4 MB',
    fileType: 'PDF',
    downloadUrl: 'https://drive.google.com/drive/folders/1leJGnwgYajB9sRN31gBTRod-hFZ0LQaA?usp=share_link'
  }, {
    id: 2,
    title: 'Výkresová dokumentace',
    description: 'Technické výkresy všech komponent vhodné pro CNC výrobu nebo ruční obrábění.',
    icon: FileImage,
    fileSize: '1.8 MB',
    fileType: 'DXF, PDF',
    downloadUrl: 'https://drive.google.com/drive/folders/1e-nOJ7FkQU1un319XVSVP753duy8UsWH?usp=share_link'
  }, {
    id: 3,
    title: '3D modely - IPT+STL',
    description: 'Modely všech dílů připravené pro 3D tisk a CAD programy.',
    icon: File,
    fileSize: '16.2 MB',
    fileType: 'IPT, STL',
    downloadUrl: 'https://drive.google.com/drive/folders/1mRAq7IsABcEc_qGTqnFc-LsNBZ4mvU19?usp=share_link'
  }, {
    id: 4,
    title: 'Prezentace',
    description: 'Přehledová prezentace celého projektu V3DSTUDIO.',
    icon: FileBadge,
    fileSize: '5.5 MB',
    fileType: 'PPTX',
    downloadUrl: 'https://docs.google.com/presentation/d/1I1oPd0tEBPpblMy8aQZUyM4XWTnuhkCn/edit?usp=share_link&ouid=112280436368393466185&rtpof=true&sd=true'
  }];

  return <div className="pt-24 min-h-screen">
      <div className="container-section">
        <motion.div className="max-w-6xl mx-auto" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }}>
          <h1 className="section-title text-center mb-12">Ke stažení</h1>
          
          <p className="text-center text-foreground/80 max-w-2xl mx-auto mb-10">
            Zde si můžete stáhnout všechny materiály potřebné pro studium, výrobu nebo vlastní
            modifikaci svěráku V3DSTUDIO.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {downloads.map((item, index) => (
              <motion.div 
                key={item.id}
                className="tech-card flex flex-col h-full"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex items-start mb-4">
                  <div className="p-3 bg-tech-blue/10 rounded-lg mr-4">
                    <item.icon className="text-tech-blue" size={24} />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">{item.title}</h3>
                    <p className="text-foreground/60 text-sm">{item.fileType} • {item.fileSize}</p>
                  </div>
                </div>
                
                <p className="text-foreground/80 mb-6 flex-grow">
                  {item.description}
                </p>
                
                <a 
                  href={item.downloadUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white bg-tech-blue hover:bg-tech-blue/90 px-4 py-2 rounded-md transition-colors mt-auto self-start"
                >
                  <Download size={18} />
                  Stáhnout
                </a>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>;
};

export default Downloads;
